// @flow
import { useCallback, useState } from 'react';

import { api } from 'app/api';

import { GET_PAYMENT_ORDER_EXPORT } from 'app/common/api/requests/cafeteria/customer/payment_orders/export';


export default function usePaymentOrderPdf(customerId: number, paymentOrderId: number, filename: string) {
  const [loading, setLoading] = useState(false);

  const handleRequestFile = useCallback(async () => {
    setLoading(true);
    await api.download(GET_PAYMENT_ORDER_EXPORT, {
      error: 'Не удалось загрузить файл',
      filename,
      params: {
        customer_id: customerId,
        payment_order_id: paymentOrderId,
        format: 'pdf',
      },
      linkProps: {
        target: '_blank',
        skipDownload: true,
      },
    });
    setLoading(false);
  }, [customerId, paymentOrderId, filename]);

  return [handleRequestFile, loading];
}
